export var valuesLegendItemAlign = ["auto", "left", "right"];
//# sourceMappingURL=LegendItemAlign.js.map